import * as React from 'react';
import * as Redux from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import BotonComponent from '../../dashboard/components/BotonNuevo';

import AlertWidget from '../../../widgets/AlertMsg';
import { SnackbarAlertWidget, ModalComponent } from '../../../widgets';
import CloseIcon from '@mui/icons-material/Close';
import ListadoMateriasDocentes from './components/ListadoMateriasDocentes';

const MateriasDocentesView = () => {
  const dispatch = Redux.useDispatch();

  const materiasStore = Redux.useSelector((state) => state.materias);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={materiasStore.alertView} />
      <Grid item md={12}>
        {/* <BotonComponent
          click={async () => {
            // await setActivoMateriasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
        /> */}
        {/* {materiasStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              // await setActivoMateriasAction(dispatch, null);
              // await allMateriasAction(dispatch, materiasStore.params);
            }}
            disabled={materiasStore.loadingAll}
            white
            text={
              materiasStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
          />
        ) : null} */}
      </Grid>
      <Grid item md={4}>
        <ListadoMateriasDocentes />
      </Grid>
      <Grid item md={8}></Grid>
      {/* <Dialog
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
        aria-labelledby="modalFormMaterias"
        maxWidth="md"
      >
        <DialogTitle id="modalFormMaterias" sx={{ padding: '10px' }}>
          {materiasStore.activo
            ? `Editar ${materiasStore.activo.nombre}`
            : 'Nueva materia'}
          <IconButton
            aria-label="close"
            onClick={() => setOpenModalForm(!openModalForm)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 5,
              color: (theme) => theme.palette.grey,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: materiasStore.activo ? 0 : null }}>
          {materiasStore.activo ? (
            <AsignarCarreras
              setOpenModalForm={(value) => setOpenModalForm(value)}
            />
          ) : (
            <FormMaterias
              activo={materiasStore.activo}
              setOpenModalForm={(value) => setOpenModalForm(value)}
            />
          )}
        </DialogContent>
      </Dialog> */}
    </Grid>
  );
};

export default MateriasDocentesView;
